import { CLEOS_API_BASE } from 'config';
import { createHttpClient } from './utils';

export default createHttpClient(`${CLEOS_API_BASE}api/v2`, { convertEmptyStrings: true });
